import React, { useState, useEffect } from 'react';
import configData from "../../config.json";
import ApiServices from '../../services/ApiServices';
import CollectionDetail from '../Collection/CollectionDetail';
import { Helmet } from "react-helmet";

import { useParams } from 'react-router-dom';

function Share() {
    const [shareData, setShareData] = useState({
        doubleCollectionItems: [],
        missingCollectionItems: []
    });
    const [collection, setCollection] = useState('');

    const { collectionId } = useParams();
    const { userId } = useParams();


    useEffect(() => {
        loadData();
    }, [])

    const loadData = async () => {

        const shareData = await ApiServices.getPublicTradeItems(userId, collectionId);
        setShareData(shareData);

        const collectionData = await ApiServices.getCollection(collectionId);
        setCollection(collectionData);
    }

    //function UpdateItemInState(item) {
    //    const index = collectionItems.findIndex(emp => emp.collectionItemId === item.collectionItemId),
    //        copyItems = [...collectionItems] // important to create a copy, otherwise you'll modify state outside of setState call
    //    copyItems[index] = item;
    //    setCollectionItems(copyItems);
    //}

    return (
        <>
            <Helmet>
                <title>{collection ? `${collection.name} - Plakplaatjesruilen` : "Collectie laden..."}</title>
                <meta name="description" content="Bekijk en beheer je plakplaatjes collectie en ruil met anderen." />
                <meta property="og:title" content={`Plakplaatjes ruilen - ${collection?.name}`} />
                <meta property="og:description" content="Voetbalsticker en andere plakplaatjes ruilen" />
                <meta property="og:image" content={`${configData.BLOB_COLLECTION_URL}${collection?.imageFile}`} />
            </Helmet>

            <div className="shareContainer">
                <CollectionDetail collection={collection} />

                <div style={{ maxWidth: '700px' }}><b>Ik zoek: </b><br />
                    {
                        shareData.missingCollectionItems.map(item => item.number).join(', ')
                    }
                </div>
                <br /><br />
                <div style={{ maxWidth: '700px' }}><b>Ik heb dubbel:</b><br />
                    {
                        shareData.doubleCollectionItems.map(item => item.number).join(', ')
                    }
                </div><br></br>


            </div>
        </>
    );
}


export default Share;